<template>
    <body class="min-h-fullscreen bg-home center-vh pt-50 pb-100" data-overlay="7">
      <div v-if="loading" class="card px-50 py-30 m-20 p-sm-20 w-700px mb-0">
        <circle-spin class="m-0" ></circle-spin>
      </div>
      <div class="card px-50 py-30 m-20 p-sm-20 w-700px mb-0" v-else>
        <div class="text-center">
          <img class="mb-10 logo-fitila" style="width: 20%" src="./../assets/static/fitila.png" alt="logo icon">
        </div>
        <div class="flexbox justify-content-between">
          <strong class="text-uppercase h3 fw-400">Welcome , {{userDetails.user_details.firstname}} {{userDetails.user_details.lastname}}</strong>
          
        </div>
        <div class="mt-20 mb-20">
            <p class="lead">What do you want to do today?</p>
            <div> 
                <button class="mb-20 btn btn-bold btn-primary mr-10" @click="checkListener" :disabled="superadmin">Log in as Listener</button>
                <button class="mb-20 btn btn-bold btn-secondary  mr-10"  @click="checkSeeker" :disabled="superadmin">Log in as Member</button>
                <button v-if="!hideAdminBtn" class="mb-20 btn btn-bold btn-primary" @click="checkAdmin">Log in as Admin</button>
            </div>       
        </div>

        <component :is="mode" @back="clearMode">
        </component>      
      </div>
      
    </body>
    
</template>

<script>
import axios from 'axios'
import router from '../router.js'
import allMixins from '../mixins.js'
import listener from "../components/user/registerListener.vue"
import member from "../components/user/registerMember.vue"
import uploadPicture from "../components/admin/uploadPicture.vue"

export default {
  name: 'home',
  mixins: [allMixins],
  data() {
    return {
      loading: true,
      log_load: false,
      mode: "", 
      superadmin: false,
      hideAdminBtn: true,
      userDetails: {}  
    };
  },
  methods: {

      checkListener() {
        if(this.userDetails.user_details.roles.some(role => role.name === "listener")){
          this.$router.push({name: 'dashboardListener'})
        }
        else 
        this.mode = 'app-listener'
      },
      checkSeeker() {
        if(this.userDetails.user_details.roles.some(role => role.name === "helpseeker")){
          this.$router.push({name: 'dashboardMember'})
        }
        else this.mode = 'app-member'
      },
      checkAdmin() {
        this.mode = ""
        if(this.userDetails.user_details.roles.some(role => role.name === "superadmin")){
          this.$router.push({name: 'dashboard'})
        }
        else if(this.userDetails.user_details.roles.some(role => role.name === "admin_member")){
          if(this.userDetails.user_details.image == null){
            this.mode = 'upload-picture'
          }
          else{
            this.$router.push({name: 'dashboard'})
          }
        }
      },  
      clearMode() {
        this.mode = ""
      },
      logOut() {
        this.log_load = true
        axios.post('/users/signout')
        .then(res => {
          this.log_load = false
          localStorage.clear()
          this.$notify({
            group: 'response',
            type: 'success',
            text: 'Successfully Logged Out',
            duration: 1500,
          })
          setTimeout(() => {
              this.$router.push('/')
            }, 2000)       
        })
        .catch(err => {
            this.log_load = false
            this.$notify({
            group: 'response',
            type: 'error',
            text:  `${err.response.data.message}`,
            duration: 2500,
          })
        }) 
      }
  },
  mounted() {
    this.loading = true
    let details = this.$jwt.decode(this.retrieveToken(window.btoa('userToken')), "inGXVHWPU9BB5q2oix1r-zaA")
      axios.get(`users/find/${details.id}`)
      .then(res => {
        this.userDetails = res.data
        this.loading = false
        if(this.userDetails.user_details.roles.some(role => role.name === "superadmin")){
          this.superadmin = true
        }
        if(this.userDetails.user_details.roles.some(role => role.name === "superadmin") || this.userDetails.user_details.roles.some(role => role.name === "admin_member")){
          this.hideAdminBtn = false
        }
      })
      .catch(err => {
        this.loading= false
            this.$notify({
            group: 'response',
            type: 'error',
            text: 'Error Occured. Kindly Log in again',
            duration: 2500,
          });
          setTimeout(() => {
            this.$router.push('/')
            }, 3000)
      })
    
  },
  components: {
    appListener: listener,
    appMember: member,
    uploadPicture
  }
};
</script>


